import React from "react";
import styles from "./titleSection.module.scss";
const TitileSection = ({ title }) => {
  return <div className={styles.title}>{title}</div>;
};

export default TitileSection;
